export default __webpack_public_path__ + "static/media/figure-triangle-3.01ca0470.svg";